import { Injectable, inject } from '@angular/core';
import {
  Resolve,
  RouterStateSnapshot,
  ActivatedRouteSnapshot,
  RedirectCommand,
} from '@angular/router';
import {
  DomainInformationResponse,
  ProductObj,
  ProductsResponse,
} from 'src/app/models/enum';
import { CommonService } from 'src/app/services/common.service';
import { OrderCompleteService } from 'src/app/services/orderComplete.service';
import { SpinnerOverlayService } from 'src/app/shared/spinner/spinner-overlay.service';

@Injectable({
  providedIn: 'root',
})
export class SquareCatalogResolver
  implements Resolve<boolean | RedirectCommand>
{
  private orderCompleteService = inject(OrderCompleteService);
  private commonService = inject(CommonService);
  private spinnerOverlayService = inject(SpinnerOverlayService);

  async resolve(
    route: ActivatedRouteSnapshot,
    _state: RouterStateSnapshot
  ): Promise<any> {
    const productObj: ProductObj = {
      id: route.params.id,
      isProductForApplication:
        window && window.location && window.location.href
          ? window.location.href.includes('store')
          : false,
    };

    this.spinnerOverlayService.startSpinning();

    try {
      const squareProducts: ProductsResponse = await this.orderCompleteService
        .getProductsByShowOrApp(productObj)
        .toPromise();

      if (
        squareProducts &&
        squareProducts.isSuccessful &&
        squareProducts.data &&
        squareProducts.data.applicationId
      ) {
        if (!productObj.isProductForApplication) {
          this.commonService.orderIdentifier = productObj.id;
        }
        this.commonService.applicationId = squareProducts.data.applicationId;

        try {
          const domainInformation: DomainInformationResponse =
            await this.getDomainInformation();
          productObj.domainInformation = domainInformation;
        } catch (error) {
          console.error('getDomainInformation error:', error);
          productObj.domainInformation = null;
        }
      }

      this.spinnerOverlayService.stopSpinning();
      productObj.squareProducts = squareProducts;
      return productObj;
    } catch (error) {
      console.error('Error during resolver:', error);
      this.spinnerOverlayService.stopSpinning();
      return {};
    }
  }

  private getDomainInformation(): Promise<DomainInformationResponse> {
    return new Promise(resolve => {
      this.commonService
        .getDomainInformation()
        .subscribe((result: DomainInformationResponse) => {
          if (result.isSuccessful && result.data) {
            resolve(result);
          }
        });
    });
  }
}
